import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-143">
      <Navigation data-id="element-144" />
      <main data-id="element-145">
        <HeroSection data-id="element-146" />
        <WelcomeSection data-id="element-147" />
        <OfferingsSection data-id="element-148" />
        <ReviewsSection data-id="element-149" />
        <AboutSection data-id="element-150" />
        <ContactSection data-id="element-151" />
      </main>
      <Footer data-id="element-152" />
    </div>;
}